let activeExchangeData = null;
let selectedExchangeVariant = null;
let CUSTOMER_EMAIL = null;
let returnCompleted = false;
let exchangeCompleted = false;

function mapDelhiveryStatus(rawStatus) {
  if (!rawStatus) return "Tracking not available";
  const s = rawStatus.toLowerCase().trim();
  if (
    ["manifested", "rts", "ready to ship"].includes(s)
  ) return "Ready to Ship";
  if (
    ["pickup scheduled", "pickup rescheduled"].includes(s)
  ) return "Pickup Scheduled";
  if (
    ["picked up", "shipment picked up", "in transit", "arrived at hub", "departed hub", "reached destination hub"].includes(s)
  ) return "In Transit";
  if (
    ["out for delivery", "ofd"].includes(s)
  ) return "Out for Delivery";
  if (
    ["delivered"].includes(s)
  ) return "Delivered";
  if (
    ["undelivered", "delivery attempted"].includes(s)
  ) return "Delivery Attempted";
  if (
    ["shipment on hold", "address issue", "customer not available", "payment pending"].includes(s)
  ) return "On Hold";
  if (
    ["rto", "returned", "rto in transit", "rto delivered"].includes(s)
  ) return "Returned to Origin";
  return rawStatus;
}

function getRemainingReturnMinutes(delhivery) {
  if (!delhivery) return null;
  const deliveredTime = new Date(delhivery.last_update).getTime();
  if (isNaN(deliveredTime)) return null;
  const now = Date.now();
  const diffMinutes = Math.floor((now - deliveredTime) / (1000 * 60));
  const TOTAL_WINDOW_MINUTES = 24 * 60; // 1440
  return Math.max(0, TOTAL_WINDOW_MINUTES - diffMinutes);
}
function markExchangePending(orderId, lineItemId) {
  const key = `pending_exchange_${orderId}_${lineItemId}`;
  sessionStorage.setItem(key, "true");
}

function applyExchangeRequestedUI(cardEl) {
  if (!cardEl) return;
  const msgEl = cardEl.querySelector(".return-msg");
  const btnWrap = cardEl.querySelector(".order-actions_button-wrapper");
  msgEl.textContent = "Exchange requested successfully";
  msgEl.classList.add("success");
  // remove buttons
  cardEl.querySelector(".btn-return")?.remove();
  cardEl.querySelector(".btn-exchange")?.remove();
  cardEl.querySelector(".btn-cancel")?.remove();
  if (btnWrap) btnWrap.style.display = "none";
}

function openExchangeFlow(order, item) {
  if (!order || !item || !item.fulfillment) return;
  const cardEl = document.querySelector(
    `.order-card[data-order-id="${order.id}"][data-line-item-id="${item.id}"]`
  );
  activeExchangeData = {
    orderId: order.id,
    orderName: order.name,
    fulfillmentLineItemId: item.fulfillment.fulfillmentLineItemId,
    currentVariantId: item.variant?.id || null,
    variants: item.fulfillment.product_variants || [],
    productHandle: item.product_handle,
    item,
    cardEl
  };
  console.log(activeExchangeData);
  selectedExchangeVariant = null;
  document.getElementById("exchange-modal").classList.add("active");
  const stepNote = document.getElementById("exchange-step-note");
  stepNote.classList.add("return-step-active");
  document.getElementById("exchange-step-1").classList.add("hidden");
  document.body.classList.add("overflow-hidden");
}

function animateReturnTimeline() {
  const items = document.querySelectorAll("#return-step-success .timeline-item");
  items.forEach(item => item.classList.remove("active"));
  setTimeout(() => {
    items[0].classList.add("active");
  }, 700);
  setTimeout(() => {
    items[1].classList.add("active");
  }, 1400);
}
function animateExchangeTimeline() {
  const items = document.querySelectorAll("#exchange-step-3 .timeline-item");
  if (!items || items.length === 0) return;
  items.forEach(item => item.classList.remove("active"));
  if (items[0]) {
    setTimeout(() => {
      items[0].classList.add("active");
    }, 700);
  }
  if (items[1]) {
    setTimeout(() => {
      items[1].classList.add("active");
    }, 1400);
  }
}
function applyReturnCancelledUI(cardEl) {
  const msgEl = cardEl.querySelector(".return-msg");
  msgEl.textContent = "Return cancelled successfully";
  cardEl.querySelector(".btn-cancel")?.remove();
  cardEl.querySelector(".btn-return")?.remove();
  cardEl.querySelector(".btn-exchange")?.remove();
  const btnWrap = cardEl.querySelector(".order-actions_button-wrapper");
  if (btnWrap) btnWrap.style.display = "none";
}
async function refreshOrdersSilently() {
  if (!CUSTOMER_EMAIL) {
    console.warn("[refreshOrdersSilently] ❌ No customer email");
    return;
  }
  try {
    const res = await fetch(
      `https://orderflow-azure.vercel.app/api/delhivery/orders-with-tracking?email=${encodeURIComponent(CUSTOMER_EMAIL)}`,
      { cache: "no-store" }
    );
    const data = await res.json();
    const orders = data.orders || [];
    sessionStorage.setItem(
      `orders_${CUSTOMER_EMAIL}`,
      JSON.stringify(orders)
    );
    renderOrders(orders);
    console.log(
      "[refreshOrdersSilently] ✅ refreshed & re-rendered",
      orders.length
    );
  } catch (e) {
    console.error("[refreshOrdersSilently] ❌ failed", e);
  }
}
document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".delhivery-tracker");
  if (!container) return;
  const email = container.dataset.email;
  CUSTOMER_EMAIL = email;
  const loader = document.getElementById("orders-loader");
  const loaderbar = document.querySelector(".loading-bar__wrapper");
  const list = document.getElementById("orders-list");
  const empty = document.getElementById("orders-empty");
  const REFRESH_INTERVAL = 1000 * 60 * 50;
  const CACHE_KEY = `orders_${email}`;
  let hasCache = false;
  const exchangeModal = document.getElementById("exchange-modal");
  if (!exchangeModal) {
    console.error("❌ Exchange modal not found in DOM");
  } else {
    exchangeModal
      .querySelector(".return-close")
      ?.addEventListener("click", () => {
        exchangeModal.classList.remove("active");
        activeExchangeData = null;
        selectedExchangeVariant = null;
        document.querySelector("body").classList.remove("overflow-hidden");
      });
    exchangeModal
      .querySelector(".return-modal__overlay")
      ?.addEventListener("click", () => {
        exchangeModal.classList.remove("active");
        activeExchangeData = null;
        selectedExchangeVariant = null;
        document.querySelector("body").classList.remove("overflow-hidden");
      });
  }

  /* ---------------- RENDER ---------------- */
  function renderOrders(orders) {
    const orderTemplate = document.getElementById("order-card-template");
    const productTemplate = document.getElementById("product-item-template");
    const trackingTemplate = document.getElementById("tracking-item-template");
    list.innerHTML = "";
    console.log("Orders count:", orders);
    orders.forEach(order => {
      order.line_items.forEach(item => {

        const pendingKey = `pending_exchange_${order.id}_${item.id}`;
        const isPendingExchange = sessionStorage.getItem(pendingKey) === "true";
        if (item.fulfillment?.return || order.return_exchange) {
          sessionStorage.removeItem(pendingKey);
        }
        // if (item.fulfillment?.return || order.return_exchange) {
        //   const key = `pending_exchange_${order.id}_${item.id}`;
        //   sessionStorage.removeItem(key);
        // }
        const card = orderTemplate.content.cloneNode(true);
        const cardEl = card.querySelector(".order-card");
        cardEl.dataset.orderId = order.id;
        cardEl.dataset.lineItemId = item.id;

        /* ORDER META */
        card.querySelector(".order-name").textContent = order.name;
        card.querySelector(".order-date").textContent =
          new Date(order.created_at).toLocaleDateString();
        const statusEl = card.querySelector(".order-status");
        let status = order.fulfillment_status || "unknown";
        if (status === "PARTIALLY_FULFILLED") {
          status = item.fulfillment?.fulfillmentLineItemId
            ? "FULFILLED"
            : "UNFULFILLED";
        }
        statusEl.textContent = status;
        statusEl.dataset.status = status.toLowerCase();
        const productsWrap = card.querySelector(".order-products");
        productsWrap.innerHTML = "";
        const prod = productTemplate.content.cloneNode(true);
        const imgEl = prod.querySelector(".product-img");
        const img = item.variant?.image;
        if (img) {
          const img150 = img.replace(/(\.(jpg|jpeg|png))/i, "_150x200$1");
          const img300 = img.replace(/(\.(jpg|jpeg|png))/i, "_300x400$1");
          imgEl.src = img150;
          imgEl.srcset = `${img150} 150w, ${img300} 300w`;
          imgEl.sizes = "150px";
        }
        imgEl.alt = item.title;
        const titleEl = card.querySelector(".product-title");
        if (titleEl) titleEl.textContent = item.title;
        const variantEl = card.querySelector(".product-sizecolor");
        if (variantEl) variantEl.textContent = item.variant?.title || "-";
        productsWrap.appendChild(prod);

        /* TRACKING */
        const body = card.querySelector(".order-body");
        body.innerHTML = "";
        const tracking = item.fulfillment?.tracking || [];
        if (!tracking.length) {
          // body.innerHTML =
          //   `<p class="tracking-muted">Tracking not available yet</p>`;
          const track = trackingTemplate.content.cloneNode(true);
          track.querySelector(".status-pill").textContent =
                "Tracking not available";
          body.appendChild(track);
        } else {
            tracking.forEach(t => {
            const d = t.delhivery;
            const track = trackingTemplate.content.cloneNode(true);
            if (!d) {
              track.querySelector(".status-pill").textContent =
                "Tracking not available";
              body.appendChild(track);
              return;
            }
            track.querySelector(".status-pill").textContent =
              mapDelhiveryStatus(d.status);
            track.querySelector(".location").textContent =
              d.last_location || "—";
            track.querySelector(".date").textContent =
              d.last_update
                ? new Date(d.last_update).toLocaleString()
                : "—";
            track.querySelector(".status-code").textContent =
              "Status Code: " + (d.status_code || "—");
            track.querySelector(".expected-delivery").textContent =
              "Expected Delivery: " + (d.expected_delivery || "—");
            track.querySelector(".track-link").href =
              `https://www.delhivery.com/track/package/${t.number}`;
            body.appendChild(track);
          });
        }
        const actionsWrap = card.querySelector(".order-actions");
        const msgEl = card.querySelector(".return-msg");
        const btnWrap = card.querySelector(".order-actions_button-wrapper");
        const btnReturn = card.querySelector(".btn-return");
        const btnExchange = card.querySelector(".btn-exchange");
        const btnCancel = card.querySelector(".btn-cancel");
        const re = order.return_exchange;
        const trackingArr = item.tracking || [];
        const trackingObj = trackingArr[0] || null;
        const deliveryStatus = trackingObj?.delhivery?.status
          ? trackingObj.delhivery.status.toLowerCase()
          : null;
        const remainingMinutes = getRemainingReturnMinutes(trackingObj?.delhivery);;

        actionsWrap.classList.remove("hidden");
        btnWrap.style.display = "none";
        btnReturn.style.display = "none";
        btnExchange.style.display = "none";
        btnCancel.style.display = "none";
        msgEl.textContent = "";
        const isFulfilled = !!item.fulfillment?.fulfillmentLineItemId;
        const hasTracking = !!trackingObj?.number;
        const isDelivered =
          deliveryStatus === "delivered" ||
          deliveryStatus === "shipment delivered";
        const r = item.fulfillment?.return;
        if (!isFulfilled) {
          msgEl.textContent = "Item not shipped yet";
        }
        else if (isFulfilled && !isDelivered) {
          msgEl.textContent =
            "Return window will open once the item is delivered";
        } 
        else if (r) {
          const status = r.status.toUpperCase();
          msgEl.textContent =
            `Return is ${status.toLowerCase().replace(/_/g, " ")}`;
          if (status === "OPEN" || status === "REQUESTED") {
            btnWrap.style.display = "";
            btnCancel.style.display = "";
            btnCancel.onclick =
              status === "OPEN"
                ? (e) => cancelReturn(e, r.id)
                : (e) => declineReturn(e, r.id);
          }
        }
        else if (remainingMinutes === 0) {
          msgEl.textContent =
            "Return window closed. contact care@cene.co.in for assistance.";
        }
        else {
          btnWrap.style.display = "";
          btnReturn.style.display = "";
          btnExchange.style.display = "";
          btnReturn.onclick = () => {
            openReturnFlow(order, item);
            btnReturn.blur();
          };
          btnExchange.onclick = () => {
            openExchangeFlow(order, item);
            btnExchange.blur();
          };
          msgEl.textContent =
            remainingMinutes > 60
              ? `Return & Exchange available for next ${Math.floor(
                  remainingMinutes / 60
                )} hours`
              : `Return & Exchange available for next ${remainingMinutes} minutes`;
        }
        async function cancelReturn(e, returnId) {
          const btn = e.currentTarget;
          const cardEl = btn.closest(".order-card");
          const loader = cardEl.querySelector(".loading-bar__wrapper");
          loader.classList.remove("hidden");
          btn.classList.add("loading");
          try {
            await fetch("https://orderflow-azure.vercel.app/api/returns/cancel", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ returnId })
            });
            applyReturnCancelledUI(cardEl);
            refreshOrdersSilently();
          } finally {
            loader.classList.add("hidden");
            btn.classList.remove("loading");
          }
        }
        async function declineReturn(e, returnId) {
          const btn = e.currentTarget;
          const cardEl = btn.closest(".order-card");
          const loader = cardEl.querySelector(".loading-bar__wrapper");
          loader.classList.remove("hidden");
          btn.classList.add("loading");
          try {
            await fetch("https://orderflow-azure.vercel.app/api/returns/decline", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ returnId })
            });
            applyReturnCancelledUI(cardEl);
            refreshOrdersSilently();
          } finally {
            loader.classList.add("hidden");
            btn.classList.remove("loading");
          }
        }
        list.appendChild(card);
      });
    });
  }
  window.renderOrders = renderOrders;

  /* ---------------- CACHE FIRST ---------------- */
  const cached = sessionStorage.getItem(CACHE_KEY);
  if (cached) {
    hasCache = true;
    renderOrders(JSON.parse(cached));
    loader.style.display = "none";
    if (loaderbar) loaderbar.classList.add("hidden");
  }

  /* ---------------- FETCH ---------------- */
  async function fetchOrders() {
    try {
      if (!hasCache) {
        loader.style.display = "block";
        if (loaderbar) loaderbar.classList.remove("hidden");
      }
      const res = await fetch(
        `https://orderflow-azure.vercel.app/api/delhivery/orders-with-tracking?email=${encodeURIComponent(email)}`,
        { cache: "no-store" }
      );
      const data = await res.json();
      const orders = data.orders || [];
      if (!orders.length) {
        empty.style.display = "block";
        return;
      }
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(orders));
      renderOrders(orders);
    } catch (e) {
      console.error("Tracking fetch failed", e);
    } finally {
      loader.style.display = "none";
      if (loaderbar) loaderbar.classList.add("hidden");
    }
  }

  /* ---------------- LOAD AFTER PAGE READY ---------------- */
  window.addEventListener("load", () => {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(fetchOrders, { timeout: 3000 });
    } else {
      setTimeout(fetchOrders, 1500);
    }
    setInterval(fetchOrders, REFRESH_INTERVAL);
  });
});


/* ================= RETURN FLOW ================= */
let activeReturnData = null;
const modal = document.getElementById("return-modal");
const closeBtn = modal?.querySelector(".return-close");
const confirmBtn = document.getElementById("confirm-return-btn");
const reasonSelect = document.getElementById("return-reason");
const errorEl = modal?.querySelector(".return-error");
const reasonButtons = document.querySelectorAll("#returnReasonGrid button");
const reasonInput = document.getElementById("return-reason");
const exchangeSuggest = document.getElementById("exchange-suggest");
const suggestExchangeBtn = document.getElementById("suggest-exchange-btn");
const noteWrap = document.getElementById("return-note-wrap");
const noteInput = document.getElementById("return-note");
const noteCount = document.getElementById("note-count");
const step1Actions = document.getElementById("return-step-1-actions");
const customerNote = noteInput?.value?.trim() || "Requested via website";
let sealAcknowledged = false;
function showReturnError(msg) {
  if (!errorEl) return;
  errorEl.textContent = msg;
  errorEl.classList.add("active");
}
function clearReturnError() {
  if (!errorEl) return;
  errorEl.textContent = "";
  errorEl.classList.remove("active");
}
reasonButtons.forEach(btn => {
  btn.addEventListener("click", () => {
    reasonButtons.forEach(b => b.classList.remove("active"));
    btn.classList.add("active");
    reasonInput.value = btn.dataset.value;
    clearReturnError();
    exchangeSuggest.classList.add("hidden");
    exchangeSuggest.classList.remove("active");
    noteWrap.classList.add("hidden");
    if (btn.dataset.value === "size_small" || btn.dataset.value === "size_big") {
      exchangeSuggest.classList.remove("hidden");
      setTimeout(() => exchangeSuggest.classList.add("active"), 10);
      step1Actions.classList.remove("hidden");
      return;
    }
    noteWrap.classList.remove("hidden");
  });
});
noteInput?.addEventListener("input", () => {
  noteCount.textContent = noteInput.value.length;
  clearReturnError();
});

suggestExchangeBtn?.addEventListener("click", () => {
  exchangeSuggest.classList.remove("active");
  setTimeout(() => {
    exchangeSuggest.classList.add("hidden");
    openExchangeFlow(activeReturnData?.order, activeReturnData?.item);
  }, 200);
});
closeBtn?.addEventListener("click", closeReturnModal);
modal?.querySelector(".return-modal__overlay")
  ?.addEventListener("click", closeReturnModal);

/* ================= OPEN RETURN MODAL ================= */
function openReturnFlow(order, item) {
  if (!order || !item || !item.fulfillment?.fulfillmentLineItemId) {
    console.warn("Return not allowed: item not fulfilled");
    return;
  }
  RETURN_STEPS.forEach(id => {
    document.getElementById(id)?.classList.add("hidden");
  });
  step1Actions.classList.add("hidden");
  document.getElementById("return-step-seal").classList.add("return-step-active");
  /* STORE ACTIVE RETURN DATA */
  activeReturnData = {
    orderId: order.id,
    fulfillmentLineItemId: item.fulfillment.fulfillmentLineItemId,
    item,
    order
  };
  console.log("Active return:", activeReturnData);
  const imgEl = document.getElementById("return-product-img");
  const img = item.variant?.image || "";
  if (img && img.includes("cdn.shopify.com")) {
    const img150 = img.replace(/(\.(jpg|jpeg|png))/i, "_150x200$1");
    const img300 = img.replace(/(\.(jpg|jpeg|png))/i, "_300x400$1");
    imgEl.src = img150;
    imgEl.srcset = `${img150} 150w, ${img300} 300w`;
    imgEl.sizes = "150px";
    imgEl.alt = item.title || "Product image";
  }
  document.getElementById("return-product-title").textContent = item.title || "";
  document.getElementById("return-product-variant").textContent = item.variant?.title || "";
  reasonSelect.value = "";
  errorEl.textContent = "";
  document.getElementById("return-step-seal").classList.remove("hidden");
  document.getElementById("return-step-form").classList.add("hidden");
  modal.classList.add("active");
  document.querySelector("body").classList.add("overflow-hidden");
  clearReturnError();
  noteInput.value = "";
  noteCount.textContent = "0";
}
const RETURN_STEPS = [
  "return-step-seal",
  "return-step-form",
  "return-step-review",
  "return-step-success"
];
function showReturnStep(stepId) {
  RETURN_STEPS.forEach(id => {
    document.getElementById(id)?.classList.add("hidden");
  });
  step1Actions.classList.add("hidden");
  document.getElementById(stepId)?.classList.remove("hidden");
}
document.getElementById("return-form-back").onclick = () => {
  const form = document.getElementById("return-step-form");
  const seal = document.getElementById("return-step-seal");
  form.classList.remove("return-step-active");
  form.classList.remove("return-step-exit-left");
  form.classList.add("return-step-exit-right");
  seal.classList.remove("hidden");
  seal.classList.remove("return-step-exit-right");
  seal.classList.add("return-step-exit-left");
  requestAnimationFrame(() => {
    seal.classList.remove("return-step-exit-left");
    seal.classList.add("return-step-active");
  });
};
document.getElementById("return-form-continue").onclick = () => {
  const reason = reasonSelect.value;
  const note = noteInput.value.trim();
  if (!reason) return showReturnError("Select a return reason");
  const isSizeIssue = reason === "size_small" || reason === "size_big";
  if (!isSizeIssue && !note) { return showReturnError("add a note"); }
  const sourceImg = document.getElementById("return-product-img");
  const reviewImg = document.getElementById("review-product-img");
  reviewImg.src = sourceImg.src;
  reviewImg.srcset = sourceImg.srcset || "";
  reviewImg.sizes = sourceImg.sizes || "";
  reviewImg.alt = sourceImg.alt || "Product image";
  const item = activeReturnData?.item;
  const refundAmountEl = document.getElementById("refund-amount");
  if (refundAmountEl && item?.amount) {
    const amount = Number(item.amount);
    refundAmountEl.textContent = `₹${amount.toLocaleString("en-IN", {
      minimumFractionDigits: 2
    })}`;
  }
  const form = document.getElementById("return-step-form");
  const review = document.getElementById("return-step-review");
  form.classList.remove("return-step-active");
  form.classList.remove("return-step-exit-right");
  form.classList.add("return-step-exit-left");
  review.classList.remove("hidden");
  review.classList.remove("return-step-exit-left");
  review.classList.add("return-step-exit-right");
  requestAnimationFrame(() => {
    review.classList.remove("return-step-exit-right");
    review.classList.add("return-step-active");
  });
};
document.getElementById("return-review-back").onclick = () => {
  const review = document.getElementById("return-step-review");
  const form = document.getElementById("return-step-form");
  review.classList.remove("return-step-active");
  review.classList.remove("return-step-exit-left");
  review.classList.add("return-step-exit-right");
  form.classList.remove("hidden");
  form.classList.remove("return-step-exit-right");
  form.classList.add("return-step-exit-left");
  requestAnimationFrame(() => {
    form.classList.remove("return-step-exit-left");
    form.classList.add("return-step-active");
  });
  document.getElementById("return-step-1-actions").classList.remove("hidden");
};

/* ================= CLOSE MODAL ================= */
function closeReturnModal() {
  if (returnCompleted) {
    refreshOrdersSilently();
    returnCompleted = false;
  }
  const success = document.getElementById("return-step-success");
  const seal = document.getElementById("return-step-seal");
  if (success && success.classList.contains("return-step-active")) {
    success.classList.remove("return-step-active");
    // success.classList.add("return-step-exit-right");
  }
    modal.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
    RETURN_STEPS.forEach(id => {
      const step = document.getElementById(id);
      if (!step) return;

      step.classList.add("hidden");
      step.classList.remove(
        "return-step-active",
        "return-step-exit-left",
        "return-step-exit-right"
      );
    });
    seal.classList.remove("hidden");
    seal.classList.add("return-step-active");
    reasonInput.value = "";
    noteInput.value = "";
    noteCount.textContent = "0";
    reasonButtons.forEach(b => b.classList.remove("active"));
    exchangeSuggest.classList.add("hidden");
    noteWrap.classList.add("hidden");
    step1Actions.classList.add("hidden");
    clearReturnError();
    const confirmCheckbox = document.getElementById("return-confirm-checkbox");
    const confirmError = document.getElementById("return-confirm-error");
    if (confirmCheckbox) confirmCheckbox.checked = false;
    if (confirmError) confirmError.style.display = "none";
    activeReturnData = null;
    sealAcknowledged = false;
    selectedExchangeVariant = null;
}
document.getElementById("return-seal-back")?.addEventListener("click", closeReturnModal);
document.getElementById("return-seal-continue")?.addEventListener("click", () => {
  sealAcknowledged = true;
  document.getElementById("return-step-seal").classList.remove("return-step-active");
  document.getElementById("return-step-seal").classList.add("return-step-exit-left");
  document.getElementById("return-step-form").classList.remove("hidden");
  requestAnimationFrame(() => {
      document.getElementById("return-step-form").classList.add("return-step-active");
    });
  step1Actions.classList.remove("hidden");
});
document
  .getElementById("return-confirm-checkbox")
  ?.addEventListener("change", () => {
    document.getElementById("return-confirm-error").style.display = "none";
  });

/* ================= CONFIRM RETURN ================= */
const MOCK_RETURN_SUCCESS = true;
document.getElementById("confirm-return-btn").onclick = async () => {
  const confirmCheckbox = document.getElementById("return-confirm-checkbox");
  const confirmError = document.getElementById("return-confirm-error");
  const confirmBtn = document.getElementById("confirm-return-btn");
  const btnLoader = confirmBtn.querySelector(".loading-bar__wrapper");

  if (!confirmCheckbox?.checked) {
    confirmError.style.display = "block";
    confirmError.textContent =
      "Confirm that the product is unused with the original tag intact";
    return;
  } else {
    confirmError.style.display = "none";
  }
  if (!activeReturnData?.orderId || !activeReturnData?.fulfillmentLineItemId) {
    showReturnError("Invalid return item");
    return;
  }
  if (!reasonSelect.value) {
    showReturnError("select a return reason");
    return;
  }
  confirmBtn.disabled = true;
  confirmBtn.classList.add("loading");
  btnLoader.classList.remove("hidden");

  // try {
  //   await submitReturn({
  //     orderId: activeReturnData.orderId,
  //     fulfillmentLineItemId: activeReturnData.fulfillmentLineItemId,
  //     reason: reasonSelect.value,
  //     customerNote: noteInput.value.trim() || "Requested via website" 
  //   });
    try {
      if (MOCK_RETURN_SUCCESS) {
        // ⏳ simulate network delay
        await new Promise(r => setTimeout(r, 600));
      } else {
        await submitReturn({
          orderId: activeReturnData.orderId,
          fulfillmentLineItemId: activeReturnData.fulfillmentLineItemId,
          reason: reasonInput.value,
          customerNote: noteInput.value.trim()
        });
      }
    const review = document.getElementById("return-step-review");
    const success = document.getElementById("return-step-success");
    const sourceImg = document.getElementById("return-product-img");
    const successImg = document.getElementById("success-product-img");
    successImg.src = sourceImg.src;
    successImg.srcset = sourceImg.srcset || "";
    successImg.sizes = sourceImg.sizes || "";
    successImg.alt = sourceImg.alt || "Product image";
    const sourceTitle = document.getElementById("return-product-title");
    const successTitle = document.getElementById("success-product-title");
    if (successTitle && sourceTitle) {
      successTitle.textContent = sourceTitle.textContent;
    }
    const item = activeReturnData?.item;
    const refundAmountEl = success?.querySelector("#refund-amount");
    if (refundAmountEl && item?.amount) {
      const amount = Number(item.amount);
      refundAmountEl.textContent = `₹${amount.toLocaleString("en-IN", {
        minimumFractionDigits: 2
      })}`;
    }
    const sourceVariant = document.getElementById("return-product-variant");
    const successVariant = document.getElementById("success-product-variant");
    if (successVariant && sourceVariant) {
      successVariant.textContent = sourceVariant.textContent;
    }
    review.classList.remove("return-step-active");
    review.classList.remove("return-step-exit-right");
    review.classList.add("return-step-exit-left");
    success.classList.remove("hidden");
    success.classList.remove("return-step-exit-left");
    success.classList.add("return-step-exit-right");
    requestAnimationFrame(() => {
      success.classList.remove("return-step-exit-right");
      success.classList.add("return-step-active");
    });
    animateReturnTimeline();
    returnCompleted = true;
    setTimeout(() => {
      review.classList.add("hidden");
      review.classList.remove("return-step-exit-left");
    }, 250);
  } catch (e) {
    showReturnError(e.message || "Return failed");
  } finally {
    // confirmBtn.disabled = false;
    // confirmBtn.textContent = "Confirm Return";
    confirmBtn.disabled = false;
    confirmBtn.classList.remove("loading");
    btnLoader.classList.add("hidden");
  }
};
const cancelReturnBtn = document.getElementById("cancel-return-btn");
cancelReturnBtn?.addEventListener("click", async () => {
  const returnId = activeReturnData?.item?.fulfillment?.return?.id;
  if (!returnId) {
    console.warn("Return ID not found in item.fulfillment.return");
    return;
  }
  cancelReturnBtn.disabled = true;
  cancelReturnBtn.classList.add("loading");
  try {
    const res = await fetch(
      "https://orderflow-azure.vercel.app/api/returns/decline",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ returnId })
      }
    );
    const json = await res.json();
    if (!res.ok) throw new Error(json.error || "Failed to cancel return");
    activeReturnData = null;
    document.getElementById("return-modal")?.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
    returnCompleted = true;
    refreshOrdersSilently?.();
  } catch (err) {
    console.error("Cancel return error:", err);
    alert(err.message || "Unable to cancel return");
  } finally {
    cancelReturnBtn.disabled = false;
    cancelReturnBtn.classList.remove("loading");
  }
});

document.getElementById("return-success-done").onclick = () => {
  closeReturnModal();
};

/* ================= API CALL ================= */
async function submitReturn({ orderId, fulfillmentLineItemId, reason, customerNote }) {
  if (!orderId || !fulfillmentLineItemId || !reason) {
    throw new Error("Missing required return parameters");
  }
  const res = await fetch(
    "https://orderflow-azure.vercel.app/api/returns/request",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        orderId,
        fulfillmentLineItemId,
        reason,
        customerNote
      })
    }
  );
  const data = await res.json();
  if (!res.ok || !data.success) {
    console.error("Return failed:", data);
    throw new Error(data.error || "Return failed");
  }
  console.log("Return success:", data.return);
  return data;
}

/* ================= EXCHANGE FLOW ================= */
const EXCHANGE_STEPS = [
  "exchange-step-note",
  "exchange-step-1",
  "exchange-step-2",
  "exchange-step-3"
];
function closeExchangeModal() {
  if (exchangeCompleted) {
    refreshOrdersSilently();
    exchangeCompleted = false;
  }
  // if (activeExchangeData?.exchangeCompleted) {
  //   applyExchangeRequestedUI(activeExchangeData.cardEl);
  //   refreshOrdersSilently();
  // }
  const success = document.getElementById("exchange-step-3");
  const seal = document.getElementById("exchange-step-note");
  if (success && success.classList.contains("return-step-active")) {
    success.classList.remove("return-step-active");
    // success.classList.add("return-step-exit-right");
  }
    document.getElementById("exchange-modal").classList.remove("active");
    document.body.classList.remove("overflow-hidden");
    EXCHANGE_STEPS.forEach(id => {
      const step = document.getElementById(id);
      if (!step) return;
      step.classList.add("hidden");
      step.classList.remove(
        "return-step-active",
        "return-step-exit-left",
        "return-step-exit-right"
      );
    });
    seal.classList.remove("hidden");
    seal.classList.add("return-step-active");
    seal.classList.remove("return-step-exit-left");
    document
    .querySelectorAll(".size-btn.active")
    .forEach(btn => btn.classList.remove("active"));
    const confirmCheckbox = document.getElementById("exchange-confirm-checkbox");
    const confirmError = document.getElementById("exchange-confirm-error");
    if (confirmCheckbox) confirmCheckbox.checked = false;
    if (confirmError) confirmError.style.display = "none";
    activeExchangeData = null;
    selectedExchangeVariant = null;
}

function populateExchangeProduct() {
  const { item, variants, currentVariantId } = activeExchangeData;
  const imgEl = document.getElementById("exchange-product-img");
  const img = item?.variant?.image || "";
  if (img && img.includes("cdn.shopify.com")) {
    const img150 = img.replace(/(\.(jpg|jpeg|png))/i, "_150x200$1");
    const img300 = img.replace(/(\.(jpg|jpeg|png))/i, "_300x400$1");
    imgEl.src = img150;
    imgEl.srcset = `${img150} 150w, ${img300} 300w`;
    imgEl.sizes = "150px";
    imgEl.alt = item.title || "Product image";
  }
  document.getElementById("exchange-product-title").textContent =
    item.title || "";
  document.getElementById("exchange-product-variant").textContent =
    item.variant?.title || "";
}
document.getElementById("exchange-seal-back-btn").onclick = () => {
  closeExchangeModal();
};
document
  .getElementById("exchange-seal-continue-btn")
  ?.addEventListener("click", () => {
    if (!activeExchangeData) return;
    populateExchangeProduct();
    const { variants, currentVariantId } = activeExchangeData;
    const sizesWrap = document.getElementById("exchange-sizes");
    sizesWrap.innerHTML = "";
    selectedExchangeVariant = null;
    if (!Array.isArray(variants) || variants.length === 0) {
      sizesWrap.innerHTML =
        `<p class="return-error">No exchange options available.</p>`;
      return;
    }
    variants.forEach(v => {
      if (!v.available) return;
      if (v.id === currentVariantId) return;
      const sizeOpt = v.options?.find(
        o => o.name?.toLowerCase() === "size"
      );
      if (!sizeOpt) return;
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "size-btn";
      btn.textContent = sizeOpt.value;
      btn.onclick = () => {
        document
          .querySelectorAll("#exchange-sizes .size-btn")
          .forEach(b => b.classList.remove("active"));
        const errorEl = document.getElementById("exchange-error");
        if (errorEl) {
          errorEl.textContent = "";
          errorEl.style.display = "none";
        }
        btn.classList.add("active");
        selectedExchangeVariant = v;
        document.getElementById("confirm-exchange-btn").disabled = false;
      };
      sizesWrap.appendChild(btn);
    });
    if (!sizesWrap.children.length) {
      sizesWrap.innerHTML =
        `<p class="return-error">No other sizes available.</p>`;
      return;
    }
    const stepNote = document.getElementById("exchange-step-note");
    const step1 = document.getElementById("exchange-step-1");
    stepNote.classList.remove("return-step-active");
    stepNote.classList.add("return-step-exit-left");
    step1.classList.remove("hidden");
    requestAnimationFrame(() => {
      step1.classList.add("return-step-active");
    });
  });
document
  .getElementById("exchange-step1-back-btn")
  ?.addEventListener("click", () => {
    const stepNote = document.getElementById("exchange-step-note");
    const step1 = document.getElementById("exchange-step-1");
    step1.classList.remove("return-step-active");
    step1.classList.remove("return-step-exit-left");
    step1.classList.add("return-step-exit-right");
    stepNote.classList.remove("hidden");
    stepNote.classList.remove("return-step-exit-right");
    stepNote.classList.add("return-step-exit-left");
    requestAnimationFrame(() => {
      stepNote.classList.remove("return-step-exit-left");
      stepNote.classList.add("return-step-active");
    });
  });
document
  .getElementById("continue-exchange-btn")
  ?.addEventListener("click", () => {
    if (!activeExchangeData) return;
    if (!selectedExchangeVariant) {
      const errorEl = document.getElementById("exchange-error");
      if (errorEl) {
        errorEl.textContent = "Select a size to continue";
        errorEl.style.display = "block";
      }
      return;
    }
    populateExchangeProduct();
    const { variants, currentVariantId } = activeExchangeData;
    const reviewImg = document.getElementById("exchange-review-img");
    const srcImg = document.getElementById("exchange-product-img");
    if (reviewImg && srcImg) {
      reviewImg.src = srcImg.src;
      reviewImg.srcset = srcImg.srcset || "";
      reviewImg.sizes = srcImg.sizes || "";
      reviewImg.alt = srcImg.alt || "Product image";
    }
    const stepNote = document.getElementById("exchange-step-1");
    const step1 = document.getElementById("exchange-step-2");
    stepNote.classList.remove("return-step-active");
    stepNote.classList.add("return-step-exit-left");
    step1.classList.remove("hidden");
    requestAnimationFrame(() => {
      step1.classList.add("return-step-active");
    });
  });
document
  .getElementById("exchange-review-back")
  ?.addEventListener("click", () => {
    const stepNote = document.getElementById("exchange-step-1");
    const step1 = document.getElementById("exchange-step-2");
    step1.classList.remove("return-step-active");
    step1.classList.remove("return-step-exit-left");
    step1.classList.add("return-step-exit-right");
    stepNote.classList.remove("hidden");
    stepNote.classList.remove("return-step-exit-right");
    stepNote.classList.add("return-step-exit-left");
    requestAnimationFrame(() => {
      stepNote.classList.remove("return-step-exit-left");
      stepNote.classList.add("return-step-active");
    });
  });
document
  .getElementById("exchange-confirm-checkbox")
  ?.addEventListener("change", () => {
    document.getElementById("exchange-confirm-error").style.display = "none";
  });
const MOCK_EXCHANGE_SUCCESS = true;
document
  .getElementById("confirm-exchange-btn")
  ?.addEventListener("click", async () => {
    const confirmCheckbox = document.getElementById("exchange-confirm-checkbox");
    const confirmError = document.getElementById("exchange-confirm-error");
    const confirmBtn = document.getElementById("confirm-exchange-btn");
    const btnLoader = confirmBtn.querySelector(".loading-bar__wrapper");
    if (!confirmCheckbox?.checked) {
      confirmError.style.display = "block";
      confirmError.textContent =
        "Confirm that the product is unused with the original tag intact";
      return;
    } else {
      confirmError.style.display = "none";
    }
    if (!activeExchangeData || !selectedExchangeVariant) return;
    const errorEl = document.getElementById("exchange-error");
    if (errorEl) {
      errorEl.textContent = "";
      errorEl.style.display = "none";
    }
    if (!activeExchangeData) return;
    const payload = {
      orderId: activeExchangeData.orderId,
      orderName: activeExchangeData.orderName,
      fulfillmentLineItemId: activeExchangeData.fulfillmentLineItemId,
      newVariantId: selectedExchangeVariant.id,
      quantity: 1,
      returnReason: "SIZE_TOO_SMALL",
      customerNote: "Exchange requested via website"
    };
    confirmBtn.disabled = true;
    exchangeCompleted = true;
    confirmBtn.classList.add("loading");
    btnLoader.classList.remove("hidden");

    // try {
    //   const res = await fetch(
    //     "https://orderflow-azure.vercel.app/api/exchange/confirm",
    //     {
    //       method: "POST",
    //       headers: { "Content-Type": "application/json" },
    //       body: JSON.stringify(payload)
    //     }
    //   );
    try {
      let res;
      if (MOCK_EXCHANGE_SUCCESS) {
        // ⏳ simulate delay
        await new Promise(r => setTimeout(r, 600));
        // ✅ mock fetch-like response
        res = {
          ok: true,
          json: async () => ({
            success: true
          })
        };
      } else {
        res = await fetch(
          "https://orderflow-azure.vercel.app/api/exchange/confirm",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
          }
        );
      }
      const json = await res.json();
      if (!res.ok) throw new Error(json.error || "Exchange failed");
      activeExchangeData.exchangeCompleted = true;
      markExchangePending(
        activeExchangeData.orderId,
        activeExchangeData.item.id
      );
      // alert("Exchange request submitted successfully");
      const sourceImg = document.getElementById("exchange-product-img");
      const successImg = document.getElementById("exchange-success-img");
      if (sourceImg && successImg) {
        successImg.src = sourceImg.src;
        successImg.srcset = sourceImg.srcset || "";
        successImg.sizes = sourceImg.sizes || "";
        successImg.alt = sourceImg.alt || "Product image";
      }
      const sourceTitle = document.getElementById("exchange-product-title");
      const successTitle = document.getElementById("exchange-success-title");
      if (sourceTitle && successTitle) {
        successTitle.textContent = sourceTitle.textContent;
      }
      const sourceVariant = document.getElementById("exchange-product-variant");
      const successVariant = document.getElementById("exchange-success-variant");
      if (sourceVariant && successVariant) {
        successVariant.textContent = sourceVariant.textContent;
      }
      const step2 = document.getElementById("exchange-step-2");
      const step3 = document.getElementById("exchange-step-3");
      step2.classList.remove("return-step-active");
      step2.classList.remove("return-step-exit-right");
      step2.classList.add("return-step-exit-left");
      step3.classList.remove("hidden");
      step3.classList.remove("return-step-exit-left");
      step3.classList.add("return-step-exit-right");
      requestAnimationFrame(() => {
        step3.classList.remove("return-step-exit-right");
        step3.classList.add("return-step-active");
        animateExchangeTimeline();
      });
      // activeExchangeData = null;
      // selectedExchangeVariant = null;
    } catch (err) {
      console.error("Exchange error:", err);
      alert(err.message || "Exchange failed. try again.");
    } finally {
      confirmBtn.disabled = false;
      confirmBtn.classList.remove("loading");
      btnLoader.classList.add("hidden");
    }
  });
document.getElementById("exchange-success-done").onclick = () => {
  closeExchangeModal();
};
document.querySelector(".exchange-close").onclick = () => {
  closeExchangeModal();
};
document.querySelector(".exchange-flow-modal__overlay").onclick = () => {
  closeExchangeModal();
};
document.addEventListener("click", async (e) => {
  const trigger = e.target.closest(".size-chart-btn");
  if (!trigger) return;
  if (!activeExchangeData?.productHandle) {
    console.warn("No productHandle for size chart");
    return;
  }
  const modal = document.getElementById("exchange-size-chart-modal");
  if (!modal) {
    console.error("Size chart modal not found");
    return;
  }
  modal.classList.add("active");
  await loadExchangeSizeChartOnce(
    activeExchangeData.productHandle
  );
});
function initSizeChartUnits(root = document) {
  root.querySelectorAll('.unit-toggle').forEach(toggle => {
    const buttons = toggle.querySelectorAll('.unit-btn');
    const chart = toggle.closest('.size-chart');
    buttons.forEach(btn => {
        btn.addEventListener('click', function () {
            buttons.forEach(b => b.classList.remove('active'));
            this.classList.add('active');

            const unit = this.dataset.unit;
            chart.querySelectorAll('[data-inch]').forEach(cell => {
            const inch = parseFloat(cell.dataset.inch);
            if (!isNaN(inch)) {
                cell.textContent = unit === 'cm' ? (inch * 2.54).toFixed(1) : inch.toFixed(1);
            }
            });
        });
    });
  });
}
async function loadExchangeSizeChartOnce(productHandle) {
  const container = document.getElementById("exchange-size-chart-content");
  if (!container || !productHandle) return;
  const loader = container.querySelector(".loading-bar__wrapper");
  if (container.dataset.loaded === "true") {
    loader?.classList.add("hidden");
    return;
  }
  loader?.classList.remove("hidden");
  try {
    const res = await fetch(
      `/products/${productHandle}?section_id=product-measurements`
    );
    if (!res.ok) {
      throw new Error("Size chart fetch failed");
    }
    const html = await res.text();
    container.innerHTML = html;
    container.dataset.loaded = "true";
    initSizeChartUnits(container);
  } catch (e) {
    console.error("Size chart error:", e);
    container.innerHTML = "<p>Size guide unavailable</p>";
  } finally {
    const newLoader = container.querySelector(".loading-bar__wrapper");
    newLoader?.classList.add("hidden");
  }
}
const sizeChartModal = document.getElementById("exchange-size-chart-modal");
const sizeChartCloseBtn = sizeChartModal?.querySelector(".exchange-modal-close");
const sizeChartOverlay = sizeChartModal?.querySelector(".exchange-modal-overlay");
sizeChartCloseBtn?.addEventListener("click", () => {
  sizeChartModal.classList.remove("active");
});
sizeChartOverlay?.addEventListener("click", () => {
  sizeChartModal.classList.remove("active");
});